export default __webpack_public_path__ + "static/media/blank_certificate.e964d2d4.png";